function ConsequenceController(psaService) {
  const ctrl = this;

  ctrl.$onInit = function() {
    ctrl.psaService = psaService;

    ctrl.types = [
      { type: 'Event', value: 'EVENT' },
      { type: 'SMS', value: 'SMS' },
      { type: 'Email', value: 'EMAIL' },
    ];
    ctrl.classes = ['Alarm', 'Warning'];

    if (ctrl.viewMode) {
      ctrl.editMode = false;
    } else {
      ctrl.editMode = true;
    }

    if (ctrl.newConsequence.items.length === 0) {
      ctrl.newConsequence.items.push({
        id: null,
        consequenceId: null,
        item: null,
      });
    }

    // if(ctrl.newConsequence.items.length === 0) {
    //   ctrl.newConsequence.items = [null];
    // } else {
    //   console.log("Editing");
    //   ctrl.numbers = ctrl.newConsequence.items;
    // }
  };

  ctrl.$onChanges = function(changes) {
    if (changes.newConsequence) {
      ctrl.newConsequence = angular.copy(ctrl.newConsequence);
    }
  };

  ctrl.typeChange = function() {
    // Empty the items array when user changes the type of consequence
    // Prevent stuff like phonenumbers in email receivers field and vice versa
    if (ctrl.newConsequence.items.length > 1) {
      ctrl.newConsequence.items = ctrl.newConsequence.items.slice(0,1);
      ctrl.newConsequence.items[0].item = null;
      } else if (ctrl.newConsequence.items.length === 1) {
        ctrl.newConsequence.items[0].item = null;
      }
  };

  ctrl.removeConsequence = function() {
    ctrl.onRemove({
      $event: {
        consequenceIndex: ctrl.index,
      },
    });
  };

  ctrl.saveConsequence = function() {
    ctrl.editMode = false;
    // Empty the items array if consequence type is event
    if (ctrl.newConsequence.type === 'EVENT') {
      ctrl.newConsequence.items = [];
    }
    ctrl.onSave({
      $event: {
        consequenceIndex: ctrl.index,
        newConsequence: ctrl.newConsequence,
      },
    });
  };

  // Enables edit mode which changes fields to editable
  ctrl.enableEdit = function() {
    ctrl.editMode = true;
    ctrl.onEdit();
  };

  // Adds a null (for now) number/email to items array.
  ctrl.addItem = function() {
    ctrl.newConsequence.items.push({
      id: null,
      consequenceId: null,
      item: null,
    });
  };
}

angular
  .module('psa.module')
  .controller('ConsequenceController', ConsequenceController);
